import Vue from "vue";
import VueI18n from "vue-i18n";
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from "../constants/trans";
import en from "@/assets/locales/en.json";

Vue.use(VueI18n);

console.log("***** Load Locale *****");

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: { en },
});
